import {isNumber} from 'util';

export class TimeUtils {

  static withZero(n) {
    return n < 10 ? '0' + n : n;
  }

  static secondsToTime(seconds) {
    if (!isNumber(seconds) || isNaN(seconds)) {
      return '--:--';
    }

    const hours = Math.floor(Math.abs(seconds) / 3600);
    const min = Math.floor(Math.abs(seconds % 3600) / 60);
    const sec = Math.floor(Math.abs(seconds) % 60);
    return (seconds < 0 ? '-' : '') + (hours ? hours + ':' : '') + TimeUtils.withZero(min) + ':' + TimeUtils.withZero(sec);
  }

}

